/** Whether the web apps animate. A user who never chose one follows their operating system. */
export const REDUCE_MOTION = {
    /** Follow the OS `prefers-reduced-motion` preference, live. */
    SYSTEM: 'system',
    /** No animations, whatever the OS says. */
    ON: 'on',
    /** Animations, whatever the OS says. */
    OFF: 'off',
};
export const REDUCE_MOTIONS = [REDUCE_MOTION.SYSTEM, REDUCE_MOTION.ON, REDUCE_MOTION.OFF];
/**
 * What a user who never saved a setting gets. Each setting defers to the browser where it has an
 * equivalent, so a first visit looks the way the person's device is set up.
 */
export const DEFAULT_USER_SETTINGS = {
    reduceMotion: REDUCE_MOTION.SYSTEM,
    language: null,
};
